const locals= {
    ceppo:[42.6717, 13.4654],
    iguana: [42.6677, 13.3915],
    morricana: [42.661, 13.4027],
    lepri: [42.6515, 13.3687],
    pizzo: [42.6468, 13.3983],
}


export {locals};